import { render, staticRenderFns } from "./SchoolCulture.vue?vue&type=template&id=aa124b08&scoped=true&"
import script from "./SchoolCulture.vue?vue&type=script&lang=js&"
export * from "./SchoolCulture.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCulture.vue?vue&type=style&index=0&id=aa124b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa124b08",
  null
  
)

export default component.exports